import { RiskLevel } from "@/model/RiskLevel";
import { DefaultLower } from "@/model/DefaultBanners";
import Logo from "@/assets/regions/surrey-logo.svg";
const Default = {
    rawCopy: "To access further help and support regarding your drinking contact i-access on 0300 222 5932 " +
        "or visit <u>https://www.surreydrugandalcohol.com/iAccessGetting-help</u>",
    logoLink: "https://www.surreydrugandalcohol.com/iAccessGetting-help"
};
const IncreasingRisk = {
    rawCopy: `For alcohol advice and support, call i-Access on 0300 222 5932`
};
const HigherRisk = {
    rawCopy: `For alcohol advice and support, call i-Access on 0300 222 5932`
};
export default {
    name: "Surrey",
    zoomLevel: 10,
    logo: {
        file: Logo,
        width: 70,
        height: 28
    },
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: Default,
        [RiskLevel.Lower]: DefaultLower,
        [RiskLevel.Increasing]: IncreasingRisk,
        [RiskLevel.Higher]: HigherRisk,
        [RiskLevel.High]: Default
    },
    regions: [
        "Elmbridge",
        "Epsom and Ewell",
        "Guildford",
        "Mole Valley",
        "Reigate and Banstead",
        "Runnymede",
        "Spelthorne",
        "Surrey Heath",
        "Tandridge",
        "Waverley",
        "Woking"
    ],
    clinics: [
        {
            name: "i-access Laurel House",
            description: "Contact ${name}: 0300 222 5932",
            phone: ["0300 222 5932"],
            location: { lat: 51.2352019, lng: -0.5849951000000146 },
            address: "Laurel House, Farnham Road Hospital, Farnham Road, Guildford, Surrey, GU2 7LX",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            isPrimaryProvider: true,
            email: "rxx.iaccess@nhs.net",
            website: "https://www.surreydrugandalcohol.com/iAccessGetting-help"
        },
        {
            name: "i-access Wingfield Resource Centre",
            location: { lat: 51.2445698, lng: -0.1614386999999624 },
            phone: ["0300 222 5932"],
            address: "St Anne's Drive, Redhill, RH1 1AU",
            times: [
                {
                    title: "Appointment only service."
                }
            ],
            email: "rxx.iaccess@nhs.net",
            website: "https://www.surreydrugandalcohol.com/iAccessGetting-help"
        },
        {
            name: "i-access Abraham Cowley Unit",
            location: { lat: 51.3773496, lng: -0.5276926999999887 },
            phone: ["0300 222 5932"],
            address: "St Peter's Hospital, Guildford Road, Chertsey, KT16 0QA",
            times: [
                {
                    title: "Appointment only service."
                }
            ],
            email: "rxx.iaccess@nhs.net",
            website: "https://www.surreydrugandalcohol.com/iAccessGetting-help"
        },
        {
            name: "Catch-22 Surrey Young People’s Substance Misuse Service (SYPSMS)",
            tagline: "Youth Service for those aged 11-21",
            location: { lat: 51.2940323, lng: -0.32882979999999407 },
            phone: [
                {
                    title: "24/7 Crisis helpline:",
                    value: "0300 222 5932"
                },
                "01372 832905"
            ],
            address: "The Mansion, 68 Church Street, Leatherhead, Surrey, KT22 8DP",
            times: [
                {
                    title: "Appointment only service."
                }
            ],
            email: "ypsm@catch-22.org.uk",
            website: "https://www.catch-22.org.uk/services/surrey-young-peoples-substance-misuse-service/"
        }
    ]
};
//# sourceMappingURL=Surrey.js.map